import React from 'react'
import { PlaceholdersLoaderGif, ImgWithPlaceholder, Button, ProgressBarMemory } from '..'
import { ShareOutlined, CardGiftcardOutlined } from '@mui/icons-material';

export function CardAlbum({ handleAction, title, files, memoryUsed, cover, coverType, memoryTotal = 500, associate = false, creationDate, nfc, sentToGift, handleDeleteAdmin, showShareNotification, showShare }) {

    return (
        <div className="card p-3 shadow">
            <div className="row g-0">
                <h5 className={`card-title fw-bold ${sentToGift ? 'col-8' : 'col-9'} d-flex align-items-center`}>
                    {showShare && <ShareOutlined
                        className={`me-2 ${showShareNotification ? 'bg-primary p-1 rounded-5' : ''}`}
                        fontSize="medium"
                    />}
                    {title}
                </h5>
                {
                    sentToGift && <div className="col-1">
                        <CardGiftcardOutlined fontSize="medium" />
                    </div>
                }
                <div className="col-3">
                    <Button otherClass={"p-0"} otherProps={{ "data-bs-toggle": "modal", "data-bs-target": "#confirmAssociate" }}
                        onClick={handleAction}>
                        {associate ? 'Associa' : 'Apri'}
                    </Button>
                </div>
            </div>
            <div className="row g-0">
                <div className="col-4 d-flex justify-content-center align-items-center cursor-pointer position-relative" onClick={handleAction}>
                    <ImgWithPlaceholder src={cover}
                        className="card-img-top pe-none"
                        alt={'image'}
                        unselectable="on"
                        placeholder={PlaceholdersLoaderGif.loader_1200_1200}
                        type={coverType}
                        isVideo={coverType && coverType.includes('video')}
                    />
                </div>
                <div className="col-8 position-relative">
                    <div className="card-body">
                        {files && <p className="card-text mb-0">
                            <span className="fw-bold me-1">Elementi:</span>
                            {files}
                        </p>}
                        {creationDate && <p className="card-text mb-0">
                            <span className="fw-bold me-1">Creazione:</span>
                            {creationDate}
                        </p>}
                        {nfc && <p className="card-text mb-0">
                            <span className='fw-bold'> Associato:</span> {nfc}
                        </p>}
                        {memoryUsed >= 0 &&
                            <><p className="card-text mb-0">
                                <span className='fw-bold'> Memoria:</span> {memoryUsed}/{memoryTotal}
                            </p>
                                <ProgressBarMemory percentage={parseFloat(memoryUsed) / parseFloat(memoryTotal) * 100} />
                            </>}
                    </div>
                </div>
                {handleDeleteAdmin && <Button otherClass={"p-0 btn-danger mt-2"}
                    onClick={handleDeleteAdmin}>
                    Elimina Definitivamente
                </Button>}
            </div>
        </div>
    );
}